import {
  COMISSIONS_LIST,
  DELETE_COMMISSION,
  GET_PROMOCODE_BY_ID,
  GET_SUBADMIN_BY_ID,
  UPDATE_PROMOCODE,
  UPDATE_SYSTEM_ACCESS_STATUS,
} from "./ApiCalls";

export default {
  BASE_URL: "https://tenee-api.suffescom.dev/api/v1",
  API_URL: "https://tenee-api.suffescom.dev/api/v1",

  // ADMIN
  LOGIN_ADMIN: "/admin/adminLogin",
  LOGOUT_ADMIN: "/admin/logout ",

  FORGET_PASSWORD_ADMIN: "/admin/forgotpassword",
  RESET_PASSWORD: "/admin/resetpassword",
  CHANGE_PASSWORD: "/admin/changepassword",
  ADMIN_UPDATE: "admin/editAdmin",
  GET_PROFILE: "/admin/me",
  UPDATE_PROFILE: "/admin/editAdmin",

  // UPLOAD FILE

  UPLOAD_FILE: "/file/add",
  UPLOAD_MULTIPLE: "/adminSetting/uploadMultipleFile",
  UPLOAD_MULTIPLE_FILE: "/file/add-multiple",

  //DASHBOARD
  NOTIFICATION: "/admin/dashboard/notification",
  NOTIFICATION_COUNT: "/admin/dashboard/notification/count",
  READ_NOTIFICATION: "/admin/dashboard/notification/read-notification",
  DASHBOARD_DATA: "/adminDashboard/getDashboardList",
  // log api
  LOGAPI_URL: "/admin/audit",

  // help

  HELP_LIST: "admin/inquiry/list",
  DELETE_INQUIRY: "admin/inquiry/delete",
  // pricing delete api
  PRICING_DELETE: "/admin/roomManagement/remove-room-pricing",



  //  Help and support
  HELPANDSUPORT: "/admin/help-support/list",
  HELP_DETAIL: "/admin/help-support/detail/",
  HOTELSTATUSCHANGE:"/admin/hotelMangement/hotel-admin/verify-un-verify",
  // accounting

  ACCOUNTING_LIST: "/admin/getUserTransactionsWithFilter",

  // ADD USER
  ADD_USER: "/admin/adduser",
  USER_LIST: "/admin/getUsersWithFilter",
  GET_USER_BY_ID: "/admin/getUserById/",
  UPDATE_USER: "/admin/editUser",

  //update  user ========
  DELETE_USER: "/admin/removeuser",

  USER_STATUS_CHANGE: "/admin/blockUnblockCustomer",
  USER_IMPORT_BY_CSV: "/admin/importCustomer",
  IMPORT_HOTEL: "/admin/hotelMangement/import/hotel",
  ARTIST_IMPORT_BY_CSV: "/admin/importArtistViaCSV",
  EXPORT_USER_CSV: "/admin/export/user",
  // export 
  EXPORT_BOOKING_CSV: "",
  EXPORT_ACCOUNTING_CSV: "/admin/transaction/export",
  LOG_EXOORT_URL: "admin/audit/export",

  // service provider
  SERVICE_PROVIDERS_LIST: "/admin/vendors",
  SERVICE_PROVIDER_VIEW: "/admin/vendor/view/",
  APPINTRO_VIEW: "admin/appintro/view/",
  ADD_SERVICE_PROVIDER: "/admin/addvendor",
  UPDATE_SERVICE_PROVIDER: "admin/updatevendor",

  DELETE_PROVIDER: "/admin/archivevendor",
  STATUS_CHANGE_SERVICE_PROVIDER: "/admin/vendors/updatestatus/all",
  SERVICE_PROVIDER_IMPORT_BY_CSV: "admin/importVendorViaCSV",

  EXPORT_SERVICE_PROVIDER_CSV: "/admin/hotelMangement/export/hotel-admin",

  HOTEL_ADMIN_BLOCK_UNBLOCK: "/admin/hotelMangement/hotel-admin/block-unblock",
  HOTEL_ADMIN_VERIFY_UNVERIFY: "/admin/hotelMangement/hotel-admin/verify-un-verify",

  // earning report
  EXPORT_HOTEL_LIST: "/admin/hotelMangement/export/hotel",

  GET_EARNING_REPORT: "/admin/transaction",

  //Event List

  EVENT_LIST: "admin/event/list",

  GET_JOB_BY_ID: "admin/post/view/",
  UPDATE_JOB: "admin/post/edit",
  DELETE_JOB_POST: "admin/post/delete",

  // service category

  SERVICE_CATEGORY_LIST: "/admin/host/getWithFilter",
  ADD_SERVICE_CATEGORY: "/admin/host/add",
  UPDATE_SERVICE_CATEGORY: "/admin/host/update",
  DELETE_SERVICE_CATEGORY: "/admin/host/remove/",
  REMOVE_APPINTRO: "/admin/appintro/remove/",
  VIEW_SERVICE_CATEGORY: "/admin/host/getById/",

  // content page
  ADD_CONTENT: "/content/add",
  CONTENT_VIEW: "/admin/contents/edit/",
  CONTENT_UPDATE: "/admin/contents/update",
  CONTENT_STATUS_CHANGE: "/content/updatestatus/all",
  CONTENT_DELETE: "/content/remove",
  CONTENT_LIST: "/admin/contents",

  // subscription
  GET_SUBSCRIPTION: "/admin/plan",
  ADD_SUBSCRIPTION: "/admin/plan/add",
  VIEW_SUBSCRIPTION: "/admin/plan/view/",
  EDIT_SUBSCRIPTION: "/admin/plan/update/",
  DELETE_SUBSCRIPTION: "/admin/plan/remove/",
  GET_SUBSCRIPTION_SUBSCRIBER: "/admin/Subscriptions",

  // Hotel Admin
  HOTEL_ADMIN_LIST: "/admin/hotelMangement/hotel-owners",
  SINGLE_HOTEL_ADMIN: "/admin/hotelMangement/fetch-hotel-admin",
  HOTEL_ADMIN_ADD: "/admin/hotelMangement/create-hotel-admin",
  HOTEL_ADMIN_UPDATE: "/admin/hotelMangement/update-hotel-admin",
  HOTEL_ADMIN_DELETE: "/admin/hotelMangement/delete-hotel-admin/",
  //Hotel URl
  HOTEL_LIST: "/admin/hotelMangement/hotel-list",
  HOTEL_CREATE: "/admin/hotelMangement/create-hotel",
  HOTEL_UPDATE: "/admin/hotelMangement/update-hotel",
  HOTEL_DELETE: "/admin/hotelMangement/delete-hotel/",
  HOTEL_DETAIL: "/admin/hotelMangement/hotel-detail/",

  // faw
  ADD_FAQ: "/admin/addFaq",
  FAQ_VIEW: "/admin/getFaqsById/",
  FAQ_UPDATE: "/admin/editFaq",
  FAQ_STATUS_CHANGE: "/faq/updatestatus/all",
  FAQ_DELETE: "/admin/deleteFaq",
  FAQ_LIST: "/admin/getAllFaqs",
  // VIEW_SERVICE_CATEGORY: "/category/view/",

  // Manage Promocode
  ADD_PROMOCODE: "/promocode/addPromoCode",
  PROMOCODE_LIST: "/promocode/getPromocodeList",
  UPDATE_PROMOCODE: "/promocode/editPromocode",
  DELETE_PROMOCODE: "/promocode/remove-promocode/",
  GET_PROMOCODE_BY_ID: "/promocode/getPromocodeDetails/",
  PROMOCODE_STATUS_CHANGE: "/promocode/updatestatus/all",
  GET_PROMOCODE_STATS: "/promocode/getPromocodeList",


  // manage Essentail
  ESSENTAIL_LIST: "/admin/amenity/hotel/getWithFilters",
  ESSENTIAL_ADD: "/admin/amenity/hotel/create",
  ESSENTIAL_UPDATE: "/admin/amenity/hotel/update/",
  ESSENTIAL_DELETE: "/admin/amenity/hotel/delete/",
  ESSENTIAL_DETAIL: "/admin/amenity/hotel/detail/",

  // manage room essential
  ROOM_ESSENTIAL_LIST: "/admin/amenity/room/getWithFilters",
  ROOM_ESSENTIAL_ADD: "/admin/amenity/room/create",
  ROOM_ESSENTIAL_UPDATE: "/admin/amenity/room/update/",
  ROOM_ESSENTIAL_DELETE: "/admin/amenity/room/delete/",
  ROOM_ESSENTIAL_DETAIL: "/admin/amenity/room/detail/",


  APP_INTRO: "/admin/appintro/list",
  REVIEW_REQUEST: "/admin/reviews-request",
   REVIEW_REQUEST_DETAILS: "/admin/reviews/details/",
   UPDATE_REVIEW_REQUEST:"/admin/reviews/update",
  ADD_INTRO_DETAIL: "/admin/appintro/view/",
  ADD_INTRO: "/admin/appintro/add",
  UPDATE_INTRO: "/admin/appintro/update",

  // manage Room type
  ROOM_TYPES: "/admin/amenity/room/room-type",
  ROOM_GET_API: "/admin/amenity/room/room-type",
  CREATE_ROOM_TYPE: "/admin/amenity/room/createUpdate-roomType",
  DETAILS_ROOM_TYPE: "/admin/amenity/room/get-single-roomType",
  ROMMTYPE_DELETE: "/admin/amenity/room/delete-room-type/",

  //------------------
  ADD_SUB_ADMIN: "/admin/addAdmin",
  UPDATE_SUB_ADMIN: "/admin/editAdmin",
  SUBADMINS_LIST: "/admin/getAllAdminList",
  DELETE_SUBADMIN: "/admin/removeSubadmin",
  GET_SUBADMIN_BY_ID: "admin/subadmin/",
  UPDATE_SYSTEM_ACCESS_STATUS: "/admin/subadmin/updatestatus/all",

  // Room list
  ROOM_LIST: "/admin/roomManagement/room-list",
  ROOM_ADD: "/admin/roomManagement/add-room",
  ROOM_UPDATE: "/admin/roomManagement/update-room",
  ROOM_DELETE: "/admin/roomManagement/remove-room/",
  ROOM_DETAIL: "",
  // room pricing
  ROOM_PRICING: "/admin/roomManagement/add-room-pricing",

  //role

  GET_ROLES: "/admin/permission/detail",
  ADD_ROLES: "/admin/permission/create",
  EDIT_ROLE: "/admin/permission/update",
  DELETE_ROLE: "/admin/permission/remove/",
  VIEW_ROLE: "/admin/permission/detailById/",
  UPDATE_ROLE_STATUS: "/admin/updateRolestatus",

  // Order management
  GET_BOOKING: "booking/getWithFilters",
  VIEW_BOOKING: "/booking/detail/",

  //  Manage Commissions
  COMMISSIONS_LIST: "/category/viewallcategory",
  DELETE_COMMISSION: "/category/remove",
  SET_COMMISSION: "category/update",
  UPDATE_DISPUTE: "/admin/help-support/toogle-status",
  SEND_REPLY: "/admin/help-support/reply",

  // set pin api url
  SET_PIN_URL: "/admin/hotelMangement/set-pin",
  PIN_LIST: "/admin/static/store",

  ADD_PROMOTION: "/admin/promotion/add",
  PROMOTION_LIST: "/admin/promotion/list",
  UPDATE_PROMOTION: "/admin/promotion/update",
  DELETE_PROMOTION: "/admin/promotion/remove/",
  GET_PROMOTION_BY_ID: "/admin/promotion/getById/",

  CONFIG_DATA: "/admin/configs/",
  BASIC_SETTING: "/adminSetting/getBasicSettingInfo",
  UPDATE_BASIC_SETTING: "/adminSetting/update-basicsetting",

  ADD_HOTEL_ADMIN: "/admin/hotelMangement/create-hotel-admin",
  HOTEL_ADMIN_APPROVE_REJECT: "/admin/hotelMangement/change-hotel-approval",
};
